"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const fluxible_addons_react_1 = require("fluxible-addons-react");
const ApplicationStore_1 = require("../stores/ApplicationStore");
class Footer extends React.Component {
    render() {
        return (React.createElement("div", null,
            React.createElement("section", { className: 'section-social   pi-social' },
                React.createElement("div", { className: 'container' },
                    React.createElement("div", { className: 'page-social' },
                        this.props.youtubeLink ?
                            React.createElement("a", { className: 'youtube', href: this.props.youtubeLink, target: '_blank', title: 'Youtube' },
                                React.createElement("i", { className: 'fa fa-youtube-play' }),
                                React.createElement("span", null, "Youtube")) : null,
                        this.props.fbLink ?
                            React.createElement("a", { className: 'facebook', href: this.props.fbLink, target: '_blank', title: 'Facebook' },
                                React.createElement("i", { className: 'fa fa-facebook' }),
                                React.createElement("span", null, "Facebook")) : null,
                        this.props.twitterLink ?
                            React.createElement("a", { className: 'twitter', href: this.props.twitterLink, target: '_blank', title: 'Twitter' },
                                React.createElement("i", { className: 'fa fa-twitter' }),
                                React.createElement("span", null, "Twitter"))
                            : null,
                        this.props.igLink ?
                            React.createElement("a", { className: 'instagram', href: this.props.igLink, target: '_blank', title: 'Instagram' },
                                React.createElement("i", { className: 'fa fa-instagram' }),
                                React.createElement("span", null, "Instagram"))
                            : null,
                        ",",
                        this.props.vkLink != null ?
                            React.createElement("a", { className: 'fa-vk', href: this.props.vkLink, target: '_blank', title: 'Vk' },
                                React.createElement("i", { className: 'fa fa-vk' }),
                                React.createElement("span", null, "VK"))
                            : null))),
            React.createElement("footer", { id: 'footer', className: 'footer' },
                React.createElement("div", { className: 'copyright text-center' },
                    React.createElement("p", null,
                        "Copyrights \u00A9 2017-",
                        new Date().getFullYear(),
                        " All Rights Reserved by xbim")))));
    }
}
class FooterProps {
}
exports.default = (0, fluxible_addons_react_1.connectToStores)(Footer, [ApplicationStore_1.default], (context, props) => {
    const appStore = context.getStore(ApplicationStore_1.default);
    return {
        vkLink: appStore.getParam('vk_link'),
        fbLink: appStore.getParam('facebook_link'),
        igLink: appStore.getParam('ig_link'),
        twitterLink: appStore.getParam('twitter_link'),
        youtubeLink: appStore.getParam('youtube_link'),
    };
});
